import { getAuthenticatedUser } from "@roman/shared/store/auth.store";
import { differenceInHours } from "date-fns";
import { ArrowButton } from "./arrowButton";

export const AccountInfo = () => {
  const pageLinks = [
    // { name: "運営からのお知らせ", href: "#" },
    // { name: "LINE連携", href: "#" },
    {
      name: "SMS認証",
      href: "/sms-registration",
      isExternal: false,
    },
    {
      name: "LINEでお問い合わせ",
      href: "https://lin.ee/PDo4CEx",
      isExternal: true,
    },
    {
      name: "招待コードの入力",
      href: "/referral/register",
      isExternal: false,
    },
    {
      name: "クーポンコードの入力",
      href: "/coupon/redeem",
      isExternal: false,
    },
    // { name: "通知設定", href: "#" },
    {
      name: "プライバシーポリシー",
      href: "/privacy-policy",
      isExternal: false,
    },
    {
      name: "利用規約",
      href: "/terms-of-service",
      isExternal: false,
    },
    {
      name: "退会申請",
      href: "/delete-me",
      isExternal: false,
    },
  ];

  const showPageLinks = ({
    name,
    href,
    isExternal,
  }: {
    name: string;
    href: string;
    isExternal: boolean;
    isSMSVerified: boolean;
  }): React.ReactElement => {
    return (
      <a
        href={href}
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noopener noreferrer" : undefined}
        className="hover:cursor-pointer border-t border-gray-200 border-solid py-[17px] flex items-center justify-between w-full"
      >
        <div className="text-base font-medium">{name}</div>
        <div>
          <div className="w-full flex items-center justify-between gap-4">
            {name === "SMS認証" && !isSMSVerified && <p className="text-destructive">未認証</p>}
            {name === "SMS認証" && isSMSVerified && <p className="text-primary">認証済み</p>}
            <ArrowButton className="rotate-90" />
          </div>
        </div>
      </a>
    );
  };

  const user = getAuthenticatedUser();
  if (!user) {
    throw new Error("User not found");
  }
  const isWithin24Hours = differenceInHours(new Date(), new Date(user.registeredAt)) < 24;
  const isSMSVerified = user.isSMSVerified;

  return (
    <div className="flex flex-col gap-[26px] items-start pt-[39px] border-b border-gray-200 border-solid">
      <p className="text-lg font-semibold -tracking-[.01em]">アカウント情報</p>
      <div className="flex flex-col items-start w-full">
        {pageLinks.map((pageLink) => {
          if (pageLink.name === "招待コードの入力" && !isWithin24Hours) {
            return;
          }
          return showPageLinks({
            name: pageLink.name,
            href: pageLink.href,
            isExternal: pageLink.isExternal,
            isSMSVerified: isSMSVerified && pageLink.name === "SMS認証",
          });
        })}
      </div>
    </div>
  );
};
